module.exports = __webpack_public_path__ + "static/media/at-home_dance_workout_online.50fc23dc.webp";